module.exports = __webpack_public_path__ + "resources/img/img_spiceware_one_01_en.62eae393a68902d16afec900c5ed9ead.png";